import React, { useCallback, useEffect, useState } from 'react';
import { Button, InputNumber, message, Modal, Select } from 'antd';
import request from '../../../../../base/request';
import PageTemplate from '../../../components/pageTemplate/PageTemplate';
import SettingItem from './components/SettingItem';
import style from './style.module.css';

const ZombieAccountSetting = (props) => {
  const [dataSource, setDataSource] = useState([]);
  const [addParams, setAddParams] = useState({
    overTime: undefined,
    overColor: ''
  });
  const [addModalVisible, setAddModalVisible] = useState(false);
  // 这个参数表明是否正在编辑中，防止多个修改
  const [isEditing, setIsEditing] = useState(false);
  const defaultColor = ["#E92525", "#FF9E0B", "#FED408", "#30D64C", "#57C6F3", "#0D84FF", "#BE5BF0"];
  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    setAddParams({
      overTime: undefined,
      overColor: ''
    });
  }, [addModalVisible]);
  const getData = useCallback(() => {
    request({
      url: '/cm-sites-media-consumer/zombie/zombiePage',
      method: 'post',
      contentType: 'json',
      body: {
        pageNum: 1,
        pageSize: 10
      },
      callBack: (res) => {
        if (res.data) {
          setDataSource(res.data);
        }
      }
    });
  }, []);

  const updateHandler = useCallback((params) => {
    request({
      url: '/cm-sites-media-consumer/zombie/save',
      method: 'post',
      contentType: 'json',
      body: params,
      callBack: (res) => {
        message.destroy();
        if (res) {
          message.success(params.id ? '修改成功' : '新增成功');
          getData();
        }
      }
    })
  }, []);
  const deleteHandler = useCallback((id) => {
    request({
      url: '/cm-sites-media-consumer/zombie/delete',
      method: 'post',
      body: {
        id
      },
      callBack: (res) => {
        message.destroy();
        if (res) {
          message.success('删除成功');
          getData();
        }
      },
      errorCallBack: () => {
        message.destroy();
        message.warning('删除失败');
      }
    })
  }, [dataSource]);

  const addHandler = useCallback(() => {
    setAddModalVisible(true);
  }, [dataSource]);
  return (
    <PageTemplate style={{ padding: '20px' }}>
      <p className={style.title}>活跃度阈值设置</p>
      <Button type='primary' onClick={addHandler}>新增</Button>
      {
        dataSource.map(item => {
          return (
            <SettingItem
              data={item}
              key={item.id}
              isEditing={isEditing}
              changeIsEditing={setIsEditing}
              defaultColor={defaultColor}
              deleteHandler={deleteHandler}
              updateHandler={updateHandler}
              cancelHandler={getData} />
          )
        })
      }
      <Modal
        title="新增阈值设置"
        visible={addModalVisible}
        onCancel={() => {
          setAddModalVisible(false)
        }}
        onOk={() => {
          if (!addParams.overTime && addParams.overTime !== 0) {
            message.destroy();
            message.warning('请输入天数');
            return;
          }
          if (!addParams.overColor) {
            message.destroy();
            message.warning('请选择颜色');
            return;
          }
          updateHandler({
            overTime: addParams.overTime,
            overColor: addParams.overColor
          });
          setAddModalVisible(false);
        }}
      >
        <div>
          天数：<InputNumber min={0} max={90} style={{ width: '150px', marginRight: '10px' }} value={addParams.overTime} onChange={(value) => {
            setAddParams({
              ...addParams,
              overTime: value
            })
          }
          } />
          颜色：<Select style={{ width: '150px', margin: '0 10px' }} value={addParams.overColor} onChange={(value) => {
            setAddParams({
              ...addParams,
              overColor: value
            })
          }}>
            {
              defaultColor.map((color, index) => (
                <Select.Option value={color} key={index}>
                  <div style={{ backgroundColor: `${color}`, width: '60px', height: '20px', marginTop: '5px' }}></div>
                </Select.Option>
              ))
            }
          </Select>
        </div>
      </Modal>
    </PageTemplate>
  )
}

export default ZombieAccountSetting;